<template>
  

    <div class="grid">
      <loading
      :active="isLoadingModel"
      :can-cancel="true"
      color="#173EA3"
      :is-full-page="fullPage"
    ></loading>
      <div class="col-12">
        <div class="card">
          <Breadcrumb :home="breadcrumbHome" :model="breadcrumbItems" />
          <Toast />
          <!-- <Toolbar class="mb-4"> -->
            <div class="p-fluid formgrid grid" style="margin-top: 2%">
              <div class="field col-12 md:col-2">
                <span class="p-float-label">
                <InputText  format="number" v-model="name" > </InputText>
                <label for="name">Route Name</label>
              </span>
              </div>
              
              <div class="field col-12 md:col-2">
                <span class="p-float-label">
                <Dropdown filter  
                  id="state" 
                  v-model="user_type_search" 
                  :options="user_type_dropdown" 
                  optionLabel="name" 
                  :optionValue="value" >
                </Dropdown>
                <label for="user_type_search">Select Route Type</label>
              </span>
              </div>

              <div class="field col-12 md:col-2">
                <span class="p-float-label">
                <InputText  format="text" v-model="state"> </InputText>
                <label for="state">State</label>
              </span>
              </div>

              <div class="field col-12 md:col-2">
              <span class="p-float-label">
                  <MultiSelect id="district" filter v-model="district_dropdownItem" :options="district_dropdownItems"
                    optionLabel="name" @change="getBlockData(2)">
                  </MultiSelect>
                <label for="district">District</label>
              </span>
            </div>

            <div class="field col-12 md:col-2" v-if="showFirstFilter">
              <span class="p-float-label">
                  <MultiSelect id="block" filter v-model="block_dropdownItem" :options="block_dropdownItems"
                    optionLabel="name" @change="getPanchayatData(2)">
                  </MultiSelect>
                <label for="block">Block</label>
              </span>
            </div>

            <div class="field col-12 md:col-2" v-if="showFirstFilter">
              <span class="p-float-label">
                  <MultiSelect id="panchayat" filter v-model="panchayat_dropdownItem" :options="panchayat_dropdownItems"
                    optionLabel="name" @change="getVillageData(1,2)">
                  </MultiSelect>
                <label for="panchayat">Panchayat</label>
              </span>
            </div>

            <div class="field col-12 md:col-2" v-if="showFirstFilter">
              <span class="p-float-label">
                  <MultiSelect id="village" filter v-model="village_dropdownItem" :options="village_dropdownItems"
                    optionLabel="name" @filter="getVillageData">
                  </MultiSelect>
                <label for="village">Village</label>
              </span>
            </div>

              <div class="field col-12 md:col-2" v-if="showFirstFilter">
                <span class="p-float-label">
                  <InputText  format="text" v-model="city"> </InputText>
                <label for="city">City</label>
              </span>
              </div>

              <div class="field col-12 md:col-2" v-if="showFirstFilter">
                <span class="p-float-label">
                <InputText maxlength="6"  format="text" v-model="pincode" onkeypress="return event.charCode >= 48 && event.charCode <= 57"> </InputText>
                <label for="pincode">Pin Code</label>
              </span>
              </div>  &nbsp;

              <div class="field col-12 md:col-2" v-if="user_key && (client_group_ids)">
                <span class="p-float-label">
                  <MultiSelect 
                  id="state" filter 
                  v-model="client_id_search"  
                  :options="client_id_dropdown" 
                  optionLabel="name" 
                  :optionValue="value"></MultiSelect>
                <label for="client">Select Client</label>
              </span>
              </div>
                  
              <div class="field col-2">
                <Button v-if="!showFirstFilter" style="color: white; background: 
        lightgreen; border: none" icon="pi pi-ellipsis-h" @click="show_filter()"  v-tooltip.bottom="'more'"/>&nbsp;
                <Button
                  icon="pi pi-search"
                  @click="search(1)"
                  v-tooltip.bottom="'Search'"
                />&nbsp;
                <Button   class="p-button-danger"  icon="pi pi-refresh" @click="reset()" v-tooltip.bottom="'Reset'" />
                <!-- <button v-if="!showFirstFilter" style="color: blue; background: none; border: none" @click="show_filter()">
                  more ...
                </button> -->
            
              </div>
                <!-- <Button
                  label="New"
                  icon="pi pi-plus"
                  class="p-button-success field col-2 md:col-2"
                  @click="openNew"
                /> -->
                <!-- <Button
                  label="Delete"
                  icon="pi pi-trash"
                  class="p-button-danger"
                  @click="confirmDeleteSelected"
                  :disabled="!selectedProducts || !selectedProducts.length"
                /> -->
                <!-- &nbsp;
                <Button
                  icon="pi pi-sync"
                  class="p-button-info mr-2"
                  @click="get_list"
                /> -->
             
                </div>
  
            <!-- <template v-slot:end> -->
              <!-- <FileUpload
                mode="basic"
                accept="image/*"
                :maxFileSize="1000000"
                label="Import"
                chooseLabel="Import"
                class="mr-2 inline-block"
              /> -->
              <!-- <Button
                  
                  icon="pi pi-plus"
                  v-tooltip.bottom="'Add'"
                  @click="openNew"
                /> &nbsp;
              <json-excel :data="product">
              <Button
                
                icon="pi pi-upload"
                v-tooltip.bottom="'Export'"
               @click="exportCSV"
              />
              </json-excel> -->
            <!-- </template> -->
        
          <DataTable
            :loading="loading"
            ref="dt"
            :lazy="true"
            :totalRecords="totalRecords"
            :paginator="true"
            :value="products"
            v-model:selection="selectedProducts"
            :dataKey="columns[0]"
            :rows="limit"
            :filters="filters"
            @page="onPage($event)"
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            :rowsPerPageOptions="[5, 10, 25, totalRecords]"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            responsiveLayout="scroll"
            style="font-size: 12px"
            :rowHover="true" showGridlines
          >
          <template #empty>
          <b style="text-align:center">No records found.</b>
        </template>
            <template #header>
              <div
                class="
                  flex flex-column
                  md:flex-row md:justify-content-between md:align-items-center
                "
              >
                <h5 class="m-0"><b> Route List</b></h5>
                <!-- Total Records:{{totalRecords}} -->
                <div>
                    <Button                  
                        icon="pi pi-plus"
                        v-tooltip.bottom="'Add'"
                        @click="openNew"/> &nbsp;
                      <json-excel :data="product">
                        
                      <Button                      
                        icon="pi pi-upload"
                        v-tooltip.bottom="'Export'"
                      @click="exportCSV"/>&nbsp;
                      </json-excel>

                  
                     
                </div>
                <!-- <span class="block mt-2 md:mt-0 p-input-icon-left">
                                  <i class="pi pi-search" />
                                  <InputText v-model="filters['global'].value" placeholder="Search..." />
                              </span> -->
              </div><div style="text-align:right;font-weight:bold"><span>Total Routes:</span>{{totalRecords}}</div>
            </template>
            <!-- <div class="card">
                  
                <InputText  format="number" placeholder="Name" v-model="name" > </InputText>&nbsp;
                <Dropdown style="width:150px" id="state" v-model="user_type_search" :options="user_type_dropdown" optionLabel="name" :optionValue="name" placeholder="Select Type"></Dropdown>
                &nbsp;<Button
                  icon="pi pi-search"
                  class="p-button-rounded p-button-success mr-2"
                  label="Search"
                  @click="search()"
                />
  
            </div> -->
            <!-- <Column v-for="(col,index) in columns" :field="col" :header="col.toUpperCase()" :key="index"></Column> -->
            <!-- <Column selectionMode="multiple" headerStyle="width: 3rem"></Column> -->

            <Column header="Sr No" style="min-width: 5rem;text-align: center;">
              <template #body="{ index}">
              <span v-if="page_no==1">{{ +index+ +1 }}</span>
                <span v-else>{{(+index+1)+limit*(page_no-1)}}</span>
              </template>
            </Column>
  
            <Column header="Status" style="min-width: 8rem ;text-align: center;" :field="columns[9]" >
              <template #body="{ data }"> 
                <span v-if="data.status=='Active' ||data.status=='active'"><badge :value=data.status severity="success"></badge></span>
              <span v-else-if="data.status=='InActive' ||data.status=='In Active'"><badge :value=data.status severity="warning"></badge></span>
              <span v-else-if="data.status=='Delete' ||data.status=='Deleted'"><badge :value=data.status severity="danger"></badge></span>
              <span v-else>-</span>
              </template>
            </Column>
  
          
             
            <Column header="Route Type" :field="columns[6]" style="text-align:center;">
              <template #body="{ data }">
                {{ data.group_type }}
              </template>
            </Column>
            <Column
              header=" Route Name"
              style="min-width: 5rem"
              >
              <template #body="{ data }">
                {{ data.name }}
              </template>
            </Column>
            
            
            <Column header="Address" :field="columns[2]" style="min-width: 10rem">
              <template #body="{ data }">
                <span v-if=" data.Address">{{data.Address}}</span>
                <span v-else>-</span>
                
              </template>
            </Column>
            <Column header="City" :field="columns[3]" style="min-width: 5rem">
              <template #body="{ data }">
                <span v-if=" data.city">{{data.city}}</span>
                <span v-else>-</span>
              </template>
            </Column>
            <Column header="State" :field="columns[4]">
              <template #body="{ data }">
               <span v-if=" data.state">{{data.state}}</span>
                <span v-else>-</span>
              </template>
            </Column>
            <!-- <Column header="Pincode" :field="columns[5]">
              <template #body="{ data }">
                {{ data.pincode }}
              </template>
            </Column> -->
            <Column header="Pincode" :field="columns[5]" style="text-align:right;">
              <template #body="{ data }">
                <span v-if=" data.pincode">{{data.pincode}}</span>
                <span v-else>-</span>
              </template>
            </Column>
            <!-- <Column header="Mobile" :field="columns[9]" style="text-align:right;">
              <template #body="{ data }">
                {{ data.mobile_number }}
              </template>
            </Column>
            <Column header="Email" :field="columns[10]">
              <template #body="{ data }">
                {{ data.email_id }}
              </template>
            </Column> -->
  
            <Column header="Action" headerStyle="min-width:20rem;">
              <template #body="slotProps">
                <Button
                  icon="pi pi-map-marker"
                  v-tooltip.bottom="'Route Map'"
                  class="p-button-rounded p-button-primary mr-2"
                  @click="view_Map(slotProps.data)"
                />
                <Button
                  icon="pi pi-eye"
                  v-tooltip.bottom="'View'"
                  class="p-button-rounded p-button-info mr-2"
                  @click="viewProduct(slotProps.data)"
                />
                <Button
                  icon="pi pi-pencil"
                  title="Edit Route"
                  v-tooltip.bottom="'Edit'"
                  class="p-button-rounded p-button-success mr-2"
                  @click="editProduct(slotProps.data)"
                />
                
                <Button
                  icon="pi pi-trash"
                  v-tooltip.bottom="'Delete'"
                  class="p-button-rounded p-button-danger mt-2"
                  @click="confirmDeleteProduct(slotProps.data)"
                />
              </template>
            </Column>
          </DataTable>
          <Sidebar
            v-model:visible="map_productDialog"
            :baseZIndex="1000"
            position="full"
          >
          <div class="col-12">
              <div class="card">
                <GoogleMap api-key="AIzaSyC-8ib8PMibUDDYoj5kzRzKwcusvw3Gztc" style="width: 100%; height: 500px" :center="start_point" :zoom="7" >
                  <Marker  :options="{ position: start_point,label: 'Start Point' }">
                  </Marker>

                  <Marker  :options="{ position: end_point,label: 'End Point' }">
                  </Marker>

                  <MarkerCluster>
                    <Marker :options="{ position: marker,title: 'stop',label: marker.stop_name,color:'green',icon:'http://maps.google.com/mapfiles/ms/icons/green-dot.png' }"   v-for="(marker, index) in markers" style="width:5px;height:5px">
                    </Marker>
                  </MarkerCluster>
    
                  <Polyline   :options="flightPath" />
                </GoogleMap>
              </div>
          </div>
          </Sidebar>
  
          <Sidebar
            v-model:visible="productDialog"
            :baseZIndex="1000"
            position="full"
          >
            <div class="col-12">
              <div class="card">
                <h5>Route Form</h5>
                <hr />
                <div class="p-fluid formgrid grid">
                  <div class="field col-12 md:col-2">
                    <label for="status">Status</label>
                    <Dropdown
                      id="status"
                      v-model="selectstatus"
                      :options="dropdownItems"
                      :value="dropdownItems.value"
                      optionLabel="name"
                      placeholder="Select One"
                      :class="{ 'p-invalid': submitted && selectstatus.value=='' }"
                      required="true"
                    ></Dropdown>
                  </div>
                  <div class="field col-12 md:col-2">
                    <label for="status">Route Type</label>
                    <Dropdown filter
                      id="status"
                      v-model="selectgroupstatus"
                      :options="groupdropdownItems"
                      :value="groupdropdownItems.value"
                      optionLabel="name"
                      placeholder="Select One"
                      :class="{ 'p-invalid': submitted && selectgroupstatus.value=='' }"
                      required="true"
                    ></Dropdown>
                  </div>
  
                  <div class="field col-12 md:col-8">
                    <label for="name">Route Name</label>
                    <InputText
                      id="name"
                      type="text"
                      v-model.trim="product.name"
                      required="true"
                      placeholder="Route Name" 
                      autofocus
                      onkeypress="return (event.charCode >= 65 && event.charCode <= 90) || 
                      (event.charCode >= 97 && event.charCode <= 122) || 
                      event.charCode == 32"
                      :class="{ 'p-invalid': submitted && !product.name }"
                    />
                  </div>
  
                  <!-- <div class="field col-12 md:col-2">
                    <label for="middeL_NAME">Middle Name</label>
                    <InputText
                      id="middeL_NAME"
                      type="text"
                      v-model.trim="product.middeL_NAME"
                      required="true"
                      autofocus
                      :class="{ 'p-invalid': submitted && !product.middeL_NAME }"
                    />
                  </div>
                  <div class="field col-12 md:col-2">
                    <label for="surname">Lastname</label>
  
                    <InputText
                      id="surname"
                      type="text"
                      v-model.trim="product.surname"
                      required="true"
                      autofocus
                      :class="{ 'p-invalid': submitted && !product.surname }"
                    />
                  </div> -->
                  <!-- <div class="field col-12 md:col-2">
                    <label for="aadhaR_CARD">Adhar No</label>
                    <InputText
                      id="aadhaR_CARD"
                      type="number"
                      v-model.trim="product.aadhaR_CARD"
                      required="true"
                      autofocus
                      :class="{ 'p-invalid': submitted && !product.aadhaR_CARD }"
                    />
                  </div> -->
                  
                  
  
                  <!-- <div class="field col-12 md:col-2">
                    <label for="disrtict">District</label>
                    <InputText
                      id="disrtict"
                      type="text"
                      v-model.trim="product.disrtict"
                      required="true"
                      autofocus
                      :class="{ 'p-invalid': submitted && !product.disrtict }"
                    />
                  </div> -->
                  <!-- <div class="field col-12 md:col-2">
                    <label for="taluka">Taluka</label>
                    <InputText
                      id="taluka"
                      type="text"
                      v-model.trim="product.taluka"
                      required="true"
                      autofocus
                      :class="{ 'p-invalid': submitted && !product.taluka }"
                    />
                  </div> -->
                  <div class="field col-12 md:col-2">
                    <label for="city">City</label>
                    <InputText
                      id="city"
                      type="text"
                      v-model.trim="product.city"
                      required="true"
                      placeholder="City" 
                      onkeypress="return (event.charCode >= 65 && event.charCode <= 90) || 
                      (event.charCode >= 97 && event.charCode <= 122) || 
                      event.charCode == 32"
                      autofocus
                      :class="{ 'p-invalid': submitted && !product.city }"
                    />
                  </div>
                  <div class="field col-12 md:col-2">
                    <label for="pincode">Pincode</label>
                    <InputText
                      id="pincode"
                      type="text"
                      maxlength="6"
                      onkeypress="return event.charCode>=48 && event.charCode<=57"
                      v-model.trim="product.pincode"
                      required="true"
                      placeholder="Pincode" 
                      autofocus
                      :class="{ 'p-invalid': submitted && !product.pincode }"
                    />
                  </div>
                  <div class="field col-12 md:col-4">
                    <!-- <label for="pincode">Start Point - {{start?start.substring(0,60):''}}</label> -->
                    <label for="pincode">Start Point</label>
                   <!-- <InputText  type="text" v-model="searchme" placeholder="Search"/>
                    
                    <Dropdown 
                      v-model="pick_search" 
                      :options="pick_dropdown"
                      :value="pick_dropdown.value" 
                      optionLabel="name"
                      id="Dropdown"
                      placeholder="Select Pick Point" 
                      :showClear="true">
                      
                    </Dropdown> -->
                    <Dropdown 
                    @change="get_location"
                    v-model="pick_search" 
                    :options="pick_dropdown" 
                    optionLabel="name" 
                    filter 
                    @filter="dropdown_list"
                    placeholder="Select Start Point"
                    :class="{ 'p-invalid': submitted && !pick_search}"
                    >
            <template #value="slotProps">
              <div class="country-item country-item-value" v-if="slotProps.value">
                <div>{{slotProps.value.name}}</div>
              </div>
                <span v-else>
                  {{slotProps.placeholder}}
                </span>
            </template>
            <template #option="slotProps">
              <span>{{slotProps.option.name}}</span>
            </template>
            
          </Dropdown>
                    
                  </div>


                  <div class="field col-12 md:col-4">
                    <label for="pincode">End Point</label>
                    <Dropdown 
                    @change="end_get_location"
                    v-model="end_pick_search" 
                    :options="end_pick_dropdown" 
                    optionLabel="name" 
                    filter 
                    @filter="end_dropdown_list"
                    placeholder="Select End Point" 
                    :class="{ 'p-invalid': submitted && !end_pick_search}"
                    >
                    <template #value="slotProps">
                      <div class="country-item country-item-value" v-if="slotProps.value">
                        <div>{{slotProps.value.name}}</div>
                      </div>
                    <span v-else>
                    {{slotProps.placeholder}}
                    </span>
                    </template>
                    <template #option="slotProps">
                    <span>{{slotProps.option.name}}</span>
                    </template>
                    </Dropdown>
                  </div>


                  <div class="field col-12 md:col-2">
                    <label for="pincode">Start Time</label>
                    <Calendar id="calendar-timeonly" 
                      placeholder="Start time" 
                      v-model="product.start_time" 
                      timeOnly hourFormat="12" 
                      :class="{ 'p-invalid': submitted && !product.start_time}"                      
                      />
                  </div>

                  <div class="field col-12 md:col-2">
                    <label for="pincode">End Time</label>
                    <Calendar id="calendar-timeonly" 
                      placeholder="End time" 
                      v-model="product.end_time" 
                      timeOnly hourFormat="12" 
                      :class="{ 'p-invalid': submitted && !product.end_time}"                      
                      />
                  </div>
                  <div class="field col-12 md:col-2">
                    <label for="state">State</label>
                    <InputText
                      id="state"
                      type="text"
                      v-model.trim="product.state"
                      required="true"
                      placeholder="State" 
                      autofocus
                      :class="{ 'p-invalid': submitted && !product.state }"
                    />
                  </div>
          <div class="field col-12 md:col-2">
            <label for="District">District</label>
              <Dropdown
                id="User"
                filter
                v-model="district_dropdownItem"
                :options="district_dropdownItems"
                optionLabel="name"
                @change="getBlockData(1)"
                placeholder="District" 
                :class="{ 'p-invalid': submitted && !district_dropdownItem }"                
              >
              </Dropdown>
          </div>
          <div class="field col-12 md:col-2">
            <label for="complaint_status">Block</label>
              <Dropdown
                id="User"
                filter
                v-model="block_dropdownItem"
                :options="block_dropdownItems"
                optionLabel="name"
                @change="getPanchayatData(1)"
                placeholder="Block"
                :class="{ 'p-invalid': submitted && !block_dropdownItem }"                
              >
              </Dropdown>
              
       
          </div>

          <div class="field col-12 md:col-2">
            <label for="panchayat">Panchayat</label>
                <Dropdown id="panchayat" filter v-model="panchayat_dropdownItem" :options="panchayat_dropdownItems"
                  optionLabel="name" placeholder="Panchayat" @change="getVillageData(1,1)">
                </Dropdown>
          </div>


          <div class="field col-12 md:col-2">
            <label for="complaint_status">Village</label>
              <Dropdown                                    
                v-model="village_dropdownItem" 
                :options="village_dropdownItems" 
                optionLabel="name" 
                placeholder="Village"
                filter 
                display="chip"
                @filter="getVillageData"
                @change="get_ward_master"                                    
                :class="{ 'p-invalid': submitted && !village_dropdownItem }"                 
                                    >
              </Dropdown>
          </div>
          <div class="field col-12 md:col-4">
                    <label for="complaint_status">Ward</label>
                      <MultiSelect 
                        v-model="ward_dropdownItem" 
                        :options="ward_dropdownItems" 
                        optionLabel="name" 
                        filter 
                        display="chip"
                        placeholder="Select Ward"    
                        :class="{ 'p-invalid': submitted && !ward_dropdownItem }"          
                        >
                      </MultiSelect>
                  </div>
          


                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="card">
                <div class="p-fluid formgrid grid">
                  <div class="field col-12">
                    <label for="address">Address</label>
  
                    <Textarea
                      id="Address"
                      type="text"
                      v-model.trim="product.Address"
                      required="true"
                      autofocus
                      :class="{ 'p-invalid': submitted && !product.Address }"
                    />
                  </div>
                  <!-- <div class="field col-12 md:col-2">
                    <label for="mobile">Mobile No</label>
                    <InputText
                      id="mobile"
                      type="number"
                      v-model.trim="product.mobile"
                      required="true"
                      autofocus
                      :class="{
                        'p-invalid': submitted && !product.mobile,
                      }"
                    />
                  </div> -->
                  <!-- <div class="field col-12 md:col-2">
                    <label for="email">Email</label>
                    <InputText
                      id="email"
                      type="text"
                      v-model.trim="product.email"
                      required="true"
                      autofocus
                      :class="{ 'p-invalid': submitted && !product.email }"
                    />
                  </div> -->
                </div>
              </div>
            </div>
  
            <div class="col-12 md:col-6">
              <Button
                v-if="product._id"
                label="UPDATE"
               
                class="p-button-success mr-1 mb-1"
                @click="adduser"
              />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <Button
                v-else
                label="ADD"
             
                class="p-button-success mr-1 mb-1"
                @click="adduser"
              />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <Button
                label="Cancel"
              
                class="p-button-danger mr-1 mb-1"
                @click="productDialog = false"
              />
            </div>
          </Sidebar>
  
          <Dialog
            v-model:visible="productDialog_old"
            :style="{ width: '450px', width: '450px' }"
            header="Year Details"
            :modal="true"
            class="p-fluid"
          >
            <div class="grid">
              <div class="col-12 md:col-12">
                <div class="field">
                  <!-- <img
              :src="'images/product/shoes.jpg'"
              :alt="product.image"
              width="150"
              class="mt-0 mx-auto mb-5 block shadow-2"
            /> -->
                </div>
                <div class="field">
                  <label for="enrollmenT_YEAR"
                    >Enrollement Year <i style="color: green">(eg.2022)</i></label
                  >
                  <InputText
                    id="enrollmenT_YEAR"
                    v-model.trim="product.enrollmenT_YEAR"
                    required="true"
                    autofocus
                    :class="{
                      'p-invalid': submitted && !product.enrollmenT_YEAR,
                    }"
                  />
                </div>
                <div class="field">
                  <label for="exaM_YEAR"
                    >Exam Year <i style="color: green">(eg.2022-23)</i></label
                  >
                  <InputText
                    id="exaM_YEAR"
                    v-model.trim="product.exaM_YEAR"
                    required="true"
                    autofocus
                    :class="{ 'p-invalid': submitted && !product.exaM_YEAR }"
                  />
                  <!-- <small class="p-invalid" v-if="submitted && !product.name"
                    >Name is required.</small
                  > -->
                </div>
                <!-- <div class="field">
                  <label for="description">Description</label>
                  <Textarea
                    id="description"
                    v-model.trim="product.description"
                    required="true"
                    autofocus
                    :class="{ 'p-invalid': submitted && !product.description }"
                  />
                </div>
                <div class="field">
                  <label for="link">Video Link</label>
                  <InputText
                    id="link"
                    v-model.trim="product.videolink"
                    required="true"
                    autofocus
                    :class="{ 'p-invalid': submitted && !product.link }"
                  />
                </div>
                
                <div class="field">
                  <label for="status">Type</label>
  
                  <Dropdown
                    id="state"
                    v-model="selectstatus"
                    :options="dropdownItems"
                    :value="dropdownItems.value"
                    optionLabel="name"
                    placeholder="Select One"
                    :class="{ 'p-invalid': submitted && !selectstatus }"
                    required="true"
                  ></Dropdown>
                </div>
  
                <div class="field">
                  <label for="status">Status</label>
  
                  <Dropdown
                    id="state"
                    v-model="selectstatus2"
                    :options="dropdownItems2"
                    :value="dropdownItems2.value"
                    optionLabel="name"
                    placeholder="Select One"
                    :class="{ 'p-invalid': submitted && !selectstatus2 }"
                    required="true"
                  ></Dropdown>
                </div> -->
              </div>
              <div class="col-12 md:col-6">
                <!-- <Button
                  v-if="product.mjyeaR_ID"
                  label="UPDATE"
                  icon="pi pi-check"
                  class="p-button-success mr-1 mb-1"
                  @click="Addyear"
                 
                />
                <Button
                  v-else
                  label="ADD"
                  icon="pi pi-check"
                  class="p-button-success mr-1 mb-1"
                  @click="Addyear"
                /> -->
              </div>
              <div class="col-12 md:col-6">
                <Button
                  label="Cancel"
                  icon="pi pi-times"
                  class="p-button-danger mr-1 mb-1"
                  @click="productDialog = false"
                />
              </div>
            </div>
          </Dialog>
  
          <Dialog
            v-model:visible="deleteProductDialog"
            :style="{ width: '450px' }"
            header="Confirm"
            :modal="true"
          >
            <div class="flex align-items-center justify-content-center">
              <i
                class="pi pi-exclamation-triangle mr-3"
                style="font-size: 2rem"
              />
              <span v-if="product"
                >Are you sure you want to delete <b>{{ product.name }}</b
                >?</span
              >
            </div>
            <template #footer>
              <Button
                label="No"
                icon="pi pi-times"
                class="p-button-text"
                @click="deleteProductDialog = false"
              />
              <Button
                label="Yes"
                icon="pi pi-check"
                class="p-button-text"
                @click="deletegroup"
              />
            </template>
          </Dialog>
  
          <Dialog
            v-model:visible="deleteProductsDialog"
            :style="{ width: '450px' }"
            header="Confirm"
            :modal="true"
          >
            <div class="flex align-items-center justify-content-center">
              <i
                class="pi pi-exclamation-triangle mr-3"
                style="font-size: 2rem"
              />
              <span v-if="product"
                >Are you sure you want to delete the selected products?</span
              >
            </div>
            <template #footer>
              <Button
                label="No"
                icon="pi pi-times"
                class="p-button-text"
                @click="deleteProductsDialog = false"
              />
              <Button
                label="Yes"
                icon="pi pi-check"
                class="p-button-text"
                @click="deleteSelectedProducts"
              />
            </template>
          </Dialog>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { FilterMatchMode } from "primevue/api";
  import ProductService from "../service/ProductService";
  import BreadcrumbService from "../service/BreadcrumbService";
  import JsonExcel from "vue-json-excel";
  import { GoogleMap, Marker,MarkerCluster,InfoWindow,Polyline } from "vue3-google-map";

  
  //import FormNewsMaster from "@/components/FormNewsMaster";
  
  
  // import axios from "axios";
  import apis from "@/apis";
  import axios from "axios";
  
  export default {
    data() {
      return {
        client_group_ids:'',
        district_dropdownItems: [],
        district_dropdownItem: null,
        block_dropdownItems: [],
        block_dropdownItem: null,
        village_dropdownItems: [],
        village_dropdownItem: null,
        panchayat_dropdownItems:[],
        panchayat_dropdownItem:null,
        showFirstFilter: false,
        start_point : {},
        end_point : {},
        markers: [],
        flightPath : {
                path:[],
                geodesic: true,
                strokeColor: "blue",
                strokeOpacity: 0.5,
                strokeWeight: 5,
              },
              map_productDialog: false,

        client_id_dropdown: [],
      client_id_search:'',
        user_key:"",
        start:'',
        end:'',
        place_details:'',
        end_place_details:'',
        searchme:'',
        name:'',
        state:'',
        city:'',
        pincode:'',
        page_no:1,
        isLoading: false,
        isLoadingModel: false,
        loading: false,
        fullPage: true,
        file_attachment: "",

        pick_dropdown: [],
        end_pick_dropdown: [],
        pick_search:'',
        end_pick_search:'',

        user_type_dropdown: [{name: 'School', code: 'School'},{name: 'Industry', code: 'Industry'},{name: 'Other', code: 'Other'}],
        user_type_search:'',

        ward_dropdownItems: [],
        ward_dropdownItem:null,

        groupdropdownItems: [{ name: "School", value: "School" },
                             {name: "Industry", value: "Industry"},
                             {name: "Other", value: "Other"}
                            ],
        selectgroupstatus:{name:"", value:""},

        dropdownItems: [
          { name: "Active", value: "Active" },
          { name: "InActive", value: "InActive" },
          { name: "Deleted", value: "Deleted" },
        ],
        selectstatus: { name: "", value: "" },


        products: null,
        productDialog: false,
        deleteProductDialog: false,
        deleteProductsDialog: false,
        lazyParams: {},
        product: {},
        selectedProducts: null,
        filters: {},
        offset: 1,
        
        
        // selectstatus2: { name: "Motivational", value: "Motivational" },
        limit: 10,
        columns: [],
        head: [
          "Data Usages",
          "Network Connectivity",
          "Students",
          "Teachers",
          "Student Registration",
          "News Master",
          "Government Panel",
          "Feedback Master",
          "User Queries",
          "Schemes Master",
          "Notice Master",
          "Subject Master",
          "Teacher Schedule Master",
          "Teacher Schedule DE Master",
          "Query Types Master",
          "Sub Query Types Master",
          "Admin Users",
          "Application Roles",
          "Departments",
          "Cast Master",
          "Year Master",
          "District Master",
          "Student Attendance",
          "Student Document",
          "Teachers",
          "Radical ids",
          "Subject Topics",
          "Query Comments",
          "Student Submit Answers",
          "Mock Tests",
          "Mock Test Papers",
          "Mock Test Results",
          "Video",
          "Syllabus",
          "Course",
        ],
        pageno: 1,
        submitted: false,
        totalRecords: 0,
        id: "",
        statuses: [
          { label: "INSTOCK", value: "instock" },
          { label: "LOWSTOCK", value: "lowstock" },
          { label: "OUTOFSTOCK", value: "outofstock" },
        ],
        BreadcrumbService : null,
        breadcrumbHome: {},
        breadcrumbItems: [],
      };
    },
    productService: null,
    
    async created() {
      this.productService = new ProductService();
      this.initFilters();
      this.user_key=localStorage.getItem("user_key");
      this.client_group_ids=localStorage.getItem('client_group_ids');
      this.get_client_list();
      this.getDistrictData();
      this.getBlockData();
      this.showFirstFilter = false; 
      this.BreadcrumbService = new BreadcrumbService();
      let Breadcrum_data = this.BreadcrumbService.groupmaster()
      this.breadcrumbHome=Breadcrum_data.home;
      this.breadcrumbItems=Breadcrum_data.items;
      
    },
    async mounted() {
      // this.productService.getProducts().then(data => this.products = data);
      this.id = this.$route.params.id;
  
      this.lazyParams = {
        first: 0,
        rows: this.limit,
        sortField: null,
        sortOrder: null,
        filters: this.filters,
      };
      if (this.totalRecords == 0) {
        await this.get_count();
      }
      await this.get_list();
      //await this.get_ward_master();
      
      //alert(this.id);
    },
    watch: {
     async $route() {
        this.products = [];
        this.columns = [];
        this.totalRecords = 0;
        this.id = this.$route.params.id;
        if (this.id) {
          await this.get_count();
          this.get_list();
        }
      },
    },
    methods: {
      getBlockData(num)
      {
        this.block_dropdownItem=null;
        this.block_dropdownItems=[];
        var district_code=[];
        this.set_loading=true;

        if(num==2)
        {
          if(this.district_dropdownItem)
          {
            for(var i=0; i<this.district_dropdownItem.length; i++)
            {
              district_code.push(this.district_dropdownItem[i].value)
            }
          }
        }
        else if(num==1)
        {
          if (this.district_dropdownItem) 
          {              
            district_code.push(this.district_dropdownItem.value);              
          }
        }
          var data=
          {
            district_code:district_code,
            count:false,
          };
          var promise=apis.getBlockData(data);
          promise.then((response)=>{
            this.set_loading=false;
            if(response.data.data)
            {
              var temp_data=[];
              for(var j=0; j<response.data.data.length; j++)
              {
              temp_data.push({
                name:response.data.data[j].name,
                value:response.data.data[j].code,
              });
              }
              this.block_dropdownItem=null;
              this.block_dropdownItems=temp_data;
            }
          });            
    },

    getPanchayatData(num)
    {
      this.panchayat_dropdownItem=null;
      this.panchayat_dropdownItems=[];
      var district_code=[];
      var block_code=[];
      this.set_loading=true;

      if(num==2)
      {
        if(this.district_dropdownItem)
        {
          for(var j=0; j<this.district_dropdownItem.length; j++)
          {
            district_code.push(this.district_dropdownItem[j].value);
          }
        }
        if(this.block_dropdownItem)
        {
          for(var i=0; i<this.block_dropdownItem.length; i++)
          {
            block_code.push(this.block_dropdownItem[i].value);
          }
        }
      }
      else if(num==1)
      {
        if(this.district_dropdownItem)
        {
          district_code.push(this.district_dropdownItem.value);
        }
        if(this.block_dropdownItem)
        {
          block_code.push(this.block_dropdownItem.value);
        }
      }  
        var data={
          district_code:district_code,
          block_code:block_code,
          count:false,
        }
        var promise=apis.getPanchayatData(data);
        var temp_data=[];
        promise.then((response)=>{
          this.set_loading=false;
          if(response.data.data)
          {
            for(var k=0; k<response.data.data.length; k++)
            {
              temp_data.push({
                name:response.data.data[k]["Local Body Name"],
                value:response.data.data[k]["Local Body Code"],
              })
            }
            this.panchayat_dropdownItem=null;
            this.panchayat_dropdownItems=temp_data;
          }
        });
            
    },

    getVillageData(search,num)
    {
      this.village_dropdownItem=null;
      this.village_dropdownItems=[];
      var district_code=[];
      var block_code=[];
      var panchayat_code=[];
      this.set_loading=true;

        if(num==2)
        {
          if (this.district_dropdownItem) {
          for (var d = 0; d < this.district_dropdownItem.length; d++) {
            district_code.push(this.district_dropdownItem[d].value);
          }
        }
        if (this.block_dropdownItem) {
          for (var c = 0; c < this.block_dropdownItem.length; c++) {
            block_code.push(this.block_dropdownItem[c].value);
          }
        }
        if (this.panchayat_dropdownItem) {
          for (var b = 0; b < this.panchayat_dropdownItem.length; b++) {
            panchayat_code.push(this.panchayat_dropdownItem[b].value);
          }
        }
      }
      else if(num==1)
      {
        if (this.district_dropdownItem) 
        {
          district_code.push(this.district_dropdownItem.value);
        }
        if (this.block_dropdownItem) 
          {
            block_code.push(this.block_dropdownItem.value);
          }

          if (this.panchayat_dropdownItem) 
          {
            panchayat_code.push(this.panchayat_dropdownItem.value);
          }
      }
        var data={
          "count": false,
          "page_no": 1,
          "limit": 10,
          district_code:district_code,
          block_code:block_code,
          panchayat_code: panchayat_code,
        }
        if(search!=1){
          data.search_name=search.value;
        }
        var temp_data=[];
        var promise=apis.getVillageData(data);
        promise.then((response)=>{
          this.set_loading=false;
          if(response.data.data)
          {
            for(var l=0; l<response.data.data.length; l++)
            {
              temp_data.push({
                name:response.data.data[l].village_name,
                value:response.data.data[l].code,
              });
            }
            this.village_dropdownItem=null,
            this.village_dropdownItems=temp_data;
          }
        });      
    },

    show_filter() {
      this.showFirstFilter = true;
    },

    async  getDistrictData() {
        this.district_dropdownItem = null;
        const client_group_ids = localStorage.getItem('client_group_ids') ? JSON.parse(localStorage.getItem('client_group_ids')):[];

      var client_id = this.client_id_search.code
        ? this.client_id_search.code
        : localStorage.getItem("client_id");
      this.loading = true;
      var data = {
        client_id: client_id,
        "client_group_ids":client_group_ids,
        count: false,
      };
      var promise = apis.getStateData(data);
      promise.then((response) => {
        this.loading = false;
        if (response.data.data) {
          var temp_data = [];
          for (let x = 0; x < response.data.data.length; x++) 
          {
            temp_data.push({
              name: response.data.data[x].name,
              value: response.data.data[x].code,
            });
            
          }
          
          this.district_dropdownItems = temp_data;
          
        }
      });
    },
      async view_Map(product)
      { 
        this.start_point= {};
        this.end_point  = {};
        this.markers    = [];
        var data        = [];
        if(product.pickup_point && product.end_point)
        {
          this.start_point={lat:parseFloat(product.pickup_point.lat) , lng:parseFloat(product.pickup_point.lng)};
          data.push({lat:parseFloat(product.pickup_point.lat) , lng:parseFloat(product.pickup_point.lng)});

          this.end_point=  {lat:parseFloat(product.end_point.lat)    , lng:parseFloat(product.end_point.lng   )};
         
        }
        else
        {
          this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Route Start Or End Point Not Found. Please Edit Route",
          life: 3000,
          });
          return false;
        }

        if (product.group_stops_details && product.group_stops_details.length>0) 
        {   var stops_data=[];
            for (let x = 0; x < product.group_stops_details.length; x++) 
              {   
                stops_data.push({lat: parseFloat(product.group_stops_details[x].location.lat) , lng:parseFloat(product.group_stops_details[x].location.lng),'stop_name':product.group_stops_details[x].stop_name});
                data.push({lat: parseFloat(product.group_stops_details[x].location.lat) , lng:parseFloat(product.group_stops_details[x].location.lng),'stop_name':product.group_stops_details[x].stop_name});
              }
                this.markers=stops_data;
              
        }
        if(product.pickup_point && product.end_point)
        {
          data.push({lat:parseFloat(product.end_point.lat)    , lng:parseFloat(product.end_point.lng   )});
        }     
              
            
            this.flightPath = {path:data}
        
        

        this.map_productDialog = true;
          
      },
      get_location()
      { 
        this.place_details='';
        var data = { PlaceId:this.pick_search.value};
        var promise = apis.geocodelocationdetails(data);
        promise.then((response) => {
          if (response.data.result) 
          {
            this.place_details=response.data.result[0];
          }
          
          
        });

      },
       dropdown_list(search)
      { 
       var data = { search:search.value};
        var promise = apis.geocodelats(data);
        promise.then((response) => {
          this.pick_dropdown=[];
          var temp=response.data.result;
          for (let a = 0; a < temp.length; a++) {
            this.pick_dropdown.push( { name: temp[a].Text, value: temp[a].PlaceId });
            
          }
        });
      },
      end_get_location()
      { 
        this.end_place_details='';
        var data = { PlaceId:this.end_pick_search.value};
        var promise = apis.geocodelocationdetails(data);
        promise.then((response) => {
          if (response.data.result) 
          {
            this.end_place_details=response.data.result[0];
          }
          
          
        });

      },
       end_dropdown_list(search)
      { 
       var data = { search:search.value};
        var promise = apis.geocodelats(data);
        promise.then((response) => {
          this.end_pick_dropdown=[];
          var temp=response.data.result;
          for (let a = 0; a < temp.length; a++) {
            this.end_pick_dropdown.push( { name: temp[a].Text, value: temp[a].PlaceId });
            
          }
        });
      },
     
             isNumber(evt) {  
        const charCode = evt.which ? evt.which : evt.keyCode;  
        if (  
          charCode > 31 &&  
          (charCode < 48 || charCode > 57) &&  
          charCode !== 46  
        ) {  
          evt.preventDefault();  
        }  
      },  
      reset()
      {
        this.name='';
          this.state='';
          this.city='';
          this.pincode='';
          this.user_type_search='';
          this.client_id_search='';
          this.showFirstFilter = false;
          this.village_dropdownItem=null;
          this.block_dropdownItem=null;
          this.district_dropdownItem=null;
          this.get_list();
          this.get_count();
      },
  
      async search(count)
      { if (count==2) 
        {
          this.name='';
          this.state='';
          this.city='';
          this.pincode='';
          this.user_type_search='';
          this.client_id_search='';
          this.showFirstFilter = false;
          this.village_dropdownItem=null;
          this.block_dropdownItem=null;
          this.district_dropdownItem=null;
          await this.getDistrictData();
          await this.getBlockData();
          await this.getPanchayatData();
        }
        if(this.name!='' && this.name.length>100)
        {
          this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter Valid Mobile Number",
          life: 3000,
        });
        return false;
        }
        await this.get_list();
        await this.get_count();
      },
      async viewProduct(product)
      {
  
        // var data=[product]
        console.log(JSON.stringify(product));
        await localStorage.setItem('savegroupdata',JSON.stringify(product));
        this.$router.push({name:"groupProfile"});
      },
      //a simple date formatting function
      dateFormat(inputDate, info) {},
      handleFileUpload() {
        this.file_attachment = this.$refs.file_attachment.files[0];
  
        //alert(this.$refs.file_attachment.files[0].name);
      },
      get_time(date)
      {
        const now = new Date(date);
        const currentTimeInMillis = now.getTime();
        return currentTimeInMillis;
      },
      async onPage(event) {
        this.lazyParams = event;
        this.page_no = event.page + 1;
        this.limit = event.rows;
        // console.log(event);
      //  await this.get_count();
        if (this.totalRecords > 0) {
          this.get_list();
        }
      },
      get_count: function () {
        var client_group_ids =[];
            if (localStorage.getItem('client_group_ids')) 
            {
                client_group_ids =JSON.parse(localStorage.getItem('client_group_ids'));
            }
            else
            {
                client_group_ids.push(localStorage.getItem('client_id'));
            }
        //var client_group_ids = localStorage.getItem('client_group_ids') ? JSON.parse(localStorage.getItem('client_group_ids')):[];
        if (this.client_id_search && this.client_id_search.length>0) 
        {
              client_group_ids = []
              for (let x = 0; x < this.client_id_search.length; x++) {
                client_group_ids.push(this.client_id_search[x].value);
                
              }
             
        }
        var type='';
        if(this.user_type_search!='')
        {
          type=this.user_type_search.code;
        }

        var block_code = [];
        var district_code = [];
        var village_code = [];
        var panchayat_code=[];
        if (this.block_dropdownItem) {
          for (var c = 0; c < this.block_dropdownItem.length; c++) {
            block_code.push(this.block_dropdownItem[c].value);
          }
        }
        if (this.district_dropdownItem) {
          for (var d = 0; d < this.district_dropdownItem.length; d++) {
            district_code.push(this.district_dropdownItem[d].value);
          }
        }
        if (this.panchayat_dropdownItem) {
          for (var f = 0; f < this.panchayat_dropdownItem.length; f++) {
            panchayat_code.push(this.panchayat_dropdownItem[f].value);
          }
        }
        if (this.village_dropdownItem) {
          for (var e = 0; e < this.village_dropdownItem.length; e++) {
            village_code.push(this.village_dropdownItem[e].value);
          }
        }
        var data = {
          
          count: true,
          group_type:type,
          name:this.name,
          state:this.state,
          city:this.city,
          pincode:this.pincode,
          district_code: district_code,
          block_code: block_code,
          village_code: village_code,
          panchayat_code: panchayat_code,
          client_id: this.client_id_search.value?this.client_id_search.value:localStorage.getItem("client_id"),
          "client_group_ids":client_group_ids,
          //user_id:localStorage.getItem("id"),
          created_by:localStorage.getItem("role_id")=='644ce01f254db83050382bf7'?localStorage.getItem("id"):''
        };
        this.loading = true;
        var promise = apis.group_list(data, this.id);
        promise.then((response) => {
          this.loading = false;
          console.log(response);
          this.totalRecords = response.data.data;
          //alert(this.totalRecords);
        });
  
        console.log(data);
      },
      get_ward_master: function()
      {
        var client_group_ids =[];
            if (localStorage.getItem('client_group_ids')) 
            {
                client_group_ids =JSON.parse(localStorage.getItem('client_group_ids'));
            }
            else
            {
                client_group_ids.push(localStorage.getItem('client_id'));
            }
            if (this.client_id_search && this.client_id_search.length>0) 
            {
                  client_group_ids = []
                  for (let x = 0; x < this.client_id_search.length; x++) {
                    client_group_ids.push(this.client_id_search[x].value);
                    
                  }
            }
            var data = {
              count: false,
              client_id: this.client_id_search.value?this.client_id_search.value:localStorage.getItem("client_id"),
              "client_group_ids":client_group_ids,
              "district_id": this.district_dropdownItem.value,
              "block_id": this.block_dropdownItem.value,
              "village_id": this.village_dropdownItem.value,

            };
            var promise = apis.WardMaster(data, this.id);
            promise.then((response) => {

              this.ward_dropdownItems=[];
              if (response.data.data.length > 0) 
              {   
                  var response_data=response.data.data;
                  for (let x = 0; x < response_data.length; x++) 
                  {
                    this.ward_dropdownItems.push({name:response_data[x].name,value:response_data[x].name});
                    
                  }
              }
            });
      },
      get_list: function () {
        var client_group_ids =[];
            if (localStorage.getItem('client_group_ids')) 
            {
                client_group_ids =JSON.parse(localStorage.getItem('client_group_ids'));
            }
            else
            {
                client_group_ids.push(localStorage.getItem('client_id'));
            }
        //var client_group_ids = localStorage.getItem('client_group_ids') ? JSON.parse(localStorage.getItem('client_group_ids')):[];

        if (this.client_id_search && this.client_id_search.length>0) 
        {
              client_group_ids = []
              for (let x = 0; x < this.client_id_search.length; x++) {
                client_group_ids.push(this.client_id_search[x].value);
                
              }
             
        }
        var type='';
        if(this.user_type_search!='')
        {
          type=this.user_type_search.code;
        }
        var block_code = [];
        var district_code = [];
        var village_code = [];
        var panchayat_code=[];
        if (this.block_dropdownItem) {
          for (var c = 0; c < this.block_dropdownItem.length; c++) {
            block_code.push(this.block_dropdownItem[c].value);
          }
        }
        if (this.district_dropdownItem) {
          for (var d = 0; d < this.district_dropdownItem.length; d++) {
            district_code.push(this.district_dropdownItem[d].value);
          }
        }
        if (this.panchayat_dropdownItem) {
          for (var f = 0; f < this.panchayat_dropdownItem.length; f++) {
            panchayat_code.push(this.panchayat_dropdownItem[f].value);
          }
        }
        if (this.village_dropdownItem) {
          for (var e = 0; e < this.village_dropdownItem.length; e++) {
            village_code.push(this.village_dropdownItem[e].value);
          }
        }
        var data = {
          limit: this.limit,
          page_no: this.page_no,
          count: false,
          group_type:type,
          name:this.name,
          state:this.state,
          city:this.city,
          pincode:this.pincode,
          district_code: district_code,
          block_code: block_code,
          village_code: village_code,
          panchayat_code:panchayat_code,
          //user_id:localStorage.getItem("id"),
          client_id: this.client_id_search.value?this.client_id_search.value:localStorage.getItem("client_id"),
          "client_group_ids":client_group_ids,
          created_by:localStorage.getItem("role_id")=='644ce01f254db83050382bf7'?localStorage.getItem("id"):''
  
        };
        this.loading = true;
        var promise = apis.group_list(data, this.id);
        promise.then((response) => {
          this.loading = false;
          console.log(response);
          this.products = response.data.data;
          console.log(this.products[0]);
          if (this.columns.length == 0) {
            if (this.products.length > 0) {
              this.columns = Object.keys(this.products[0]);
            }
          }
        });
  
        console.log(data);
      },
      formatCurrency(value) {
        if (value)
          return value.toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
          });
        return;
      },
      openNew() {
        this.product = {};
        this.submitted = false;
        this.village_dropdownItem=null;
        this.block_dropdownItem=null;
        this.district_dropdownItem=null;
        this.ward_dropdownItem=null
        this.productDialog = true;
      },
      hideDialog() {
        this.productDialog = false;
        this.submitted = false;
      },
      time_converter(data)
      {
        const date = new Date(data); // create a Date object with the given UTC date and time 
        const options = { hour: 'numeric', minute: '2-digit', hour12: true }; // define the options for the time format
        const time = date.toLocaleString('en-US', options); // convert the date and time to a string in the specified format and time zone
        return time;
      },
      get_client_list()
    {       const client_group_ids = localStorage.getItem('client_group_ids') ? JSON.parse(localStorage.getItem('client_group_ids')):[];

      var data = { count: false};
      var promise = apis.getclientist(data);
        promise.then((response) => {
          // if(response.data.data){
          // response.data.data
          //   .filter(item => item.client_name)
          //   .map(item => this.client_id_dropdown.push({ name: item.client_name, value: item._id }));
          // }
          var temp_data = [];

                    for (let x = 0; x < response.data.data.length; x++) {
                        const clientData = response.data.data[x];
                        
                        if (clientData.client_name && (client_group_ids.length === 0 || client_group_ids.includes(clientData._id))) {
                            temp_data.push({ name: clientData.client_name, value: clientData._id });
                        }
                    }

                    this.client_id_dropdown = temp_data;
        });
    },
      to_timestamp(data)
      {
    
        if (data) {
          const timeString = data;
        const date = new Date(`01/01/2000 ${timeString}`);
        const timestamp = Math.floor(date.getTime() / 1000);
        return timestamp;
        }
        else
        {
          return '';
        }
        
        
      },
      async adduser() {
        this.submitted = true;
        if (!this.selectstatus.value) {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Select Status",
            life: 3000,
          });
          return false;
        }
        if (!this.selectgroupstatus.value) {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Select Route type",
            life: 3000,
          });
          return false;
        }
        if (!this.product.name) {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Enter Route Name",
            life: 3000,
          });
          return false;
        }
        
        if (!this.product.city) {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Enter City",
            life: 3000,
          });
          return false;
        }
        
        if (!this.product.pincode) {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Enter Pincode",
            life: 3000,
          });
          return false;
        }
        
        if (!this.pick_search) {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Select Start Point",
            life: 3000,
          });
          return false;
        }
        

        if (!this.end_pick_search) {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Select End Point",
            life: 3000,
          });
          return false;
        }

        if (!this.product.start_time) {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Enter Start Time",
            life: 3000,
          });
          return false;
        }

        if (!this.product.end_time) {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Enter End Time",
            life: 3000,
          });
          return false;
        }

        if (!this.product.state) {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Enter State Name",
            life: 3000,
          });
          return false;
        }
        
        if (!this.district_dropdownItem) {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Select District",
            life: 3000,
          });
          return false;
        }
        
        if (!this.block_dropdownItem) {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Select Block",
            life: 3000,
          });
          return false;
        }
        
        if (!this.village_dropdownItem) {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Select Village",
            life: 3000,
          });
          return false;
        }
        if(!this.ward_dropdownItem){
          this.$toast.add({
              severity:"error",
              summary:"error",
              details:"please Select Ward",
              life: 3000,
          });
          return false;
        }

        if (!this.product.Address) {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Enter address",
            life: 3000,
          });
          return false;
        }
        if (this.place_details==undefined || this.place_details==null || this.place_details==[]) {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Enter Start point",
            life: 3000,
          });
          return false;
        }
        if (this.end_place_details==undefined || this.end_place_details==null || this.end_place_details==[]) {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Enter End point",
            life: 3000,
          });
          return false;
        }        
        
         var start_time=this.time_converter(this.product.start_time);
         var end_time=this.time_converter(this.product.end_time);

         var start_timestamp=this.to_timestamp(start_time);
         var end_timestamp=this.to_timestamp(end_time);
        
         var ward = [];
            if (this.ward_dropdownItem) 
          {
            for (var d = 0; d < this.ward_dropdownItem.length; d++) 
            {
              ward.push(this.ward_dropdownItem[d].value);
            }
          }
  
        //edit
        if (this.product._id) {
          this.product.pickup_point=this.place_details;
          this.product.end_point=this.end_place_details;

            var data = {
          "_id":this.product._id,
          "name": this.product.name,
          "Address": this.product.Address,
          "city": this.product.city,
          "state": this.product.state,
          "pincode": this.product.pincode,
          "group_type": this.selectgroupstatus.value,
          "parent_group_id": "",
          "pickup_point": this.product.pickup_point,
          "end_point": this.product.end_point,
          "status": this.selectstatus.value,
          "client_id": this.client_id_search.value?this.client_id_search.value:localStorage.getItem("client_id"),
          "created_at": "",
          "updated_at": "",
          "created_by": localStorage.getItem("id"),
          "updated_by": "",
          "start_time":start_time,
          "end_time":end_time,
          "start_timestamp":start_timestamp,
          "end_timestamp":end_timestamp,
          "district_id": this.district_dropdownItem.value,
          "block_id": this.block_dropdownItem.value,
          "village_id": this.village_dropdownItem.value,
          "district_name": this.district_dropdownItem.name,
          "block_name": this.block_dropdownItem.name,
          "village_name": this.village_dropdownItem.name,
          "ward":ward
          };
         
          this.isLoadingModel = true;
          var promise = apis.editgroup(data);
          promise
            .then((responseapi) => {
              this.$swal(responseapi.data.message);
              this.isLoadingModel = false;
              this.productDialog = false;
              this.get_list();
              this.get_count();
            })
            .catch((error) => {
              //console.log(error);
              this.isLoadingModel = false;
              this.productDialog = false;
  
              this.$swal.fire(error.response.data);
              this.get_list();
              this.get_count();
            });
        }
        //add-----------------------------------------------------------------------------------------------------------------
        else {
          var data1 = {
          "name": this.product.name,
          "Address": this.product.Address,
          "city": this.product.city,
          "state": this.product.state,
          "pincode": this.product.pincode,
          "group_type": this.selectgroupstatus.value,
          "parent_group_id": "",
          "pickup_point": this.place_details,
          "end_point": this.end_place_details,
          "status": this.selectstatus.value,
          "client_id": this.client_id_search.value?this.client_id_search.value:localStorage.getItem("client_id"),
          "created_at": "",
          "updated_at": "",
          "created_by": localStorage.getItem("id"),
          "updated_by": "",
          "start_time":start_time,
          "end_time":end_time,
          "start_timestamp":start_timestamp,
          "end_timestamp":end_timestamp,
          "district_id": this.district_dropdownItem.value,
          "block_id": this.block_dropdownItem.value,
          "village_id": this.village_dropdownItem.value,
          "district_name": this.district_dropdownItem.name,
          "block_name": this.block_dropdownItem.name,
          "village_name": this.village_dropdownItem.name,
          "ward":ward
          };
          this.isLoadingModel = true;
          var promises = apis.addgroup(data1);
          promises
            .then((response) => {
              this.isLoadingModel = false;
              this.productDialog = false;
              this.$swal(response.data.message);
              this.get_list();
              this.get_count();
            })
            .catch((error) => {
              //console.log(error);
              this.isLoadingModel = false;
              this.productDialog = false;
  
              this.$swal.fire(error.response.data);
              this.get_list();
              this.get_count();
            });
        }
  
        this.selectstatus = { name: "", value: "" };
        this.selectgroupstatus={name:"",value:""};
        this.pick_dropdown=[];
        this.end_pick_dropdown=[];
        this.place_details='';
        this.end_place_details='';
      },
      saveProduct() {
        this.submitted = true;
        if (this.product.name.trim()) {
          if (this.product.id) {
            this.product.inventoryStatus = this.product.inventoryStatus.value
              ? this.product.inventoryStatus.value
              : this.product.inventoryStatus;
            this.products[this.findIndexById(this.product.id)] = this.product;
            this.$toast.add({
              severity: "success",
              summary: "Successful",
              detail: "Product Updated",
              life: 3000,
            });
          } else {
            this.product.id = this.createId();
            this.product.code = this.createId();
            this.product.image = "product-placeholder.svg";
            this.product.inventoryStatus = this.product.inventoryStatus
              ? this.product.inventoryStatus.value
              : "INSTOCK";
            this.products.push(this.product);
            this.$toast.add({
              severity: "success",
              summary: "Successful",
              detail: "Product Created",
              life: 3000,
            });
          }
          this.productDialog = false;
          this.product = {};
        }
      },

      format_time(data)
      {
        if(data) 
        {
          const date = new Date(data);
          return date;
        }
        else
        {
          return '';
        }

      },
      format_time2(data)
      {
        const timeString = data; // the time string to convert
        const defaultDateString = new Date().toDateString(); // use the current date as the default date
        const dateTimeString = `${defaultDateString} ${timeString}`; // combine the default date and the time string
        const date = new Date(dateTimeString); // create a Date object from the complete date and time string
        return date;

      },
      
    async  editProduct(product) {
        this.file_attachment = "";
        this.product = { ...product };
        this.productDialog = true;
        this.ward_dropdownItem=null;
        var temp=[];
        if (this.product.ward && this.product.ward.length>0) 
        {
          for (let q = 0; q < this.product.ward.length; q++) 
          {
            temp.push({
              name:this.product.ward[q],
              value:this.product.ward[q]})
          }
          this.ward_dropdownItem=temp;
        }
        //this.ward_dropdownItem.value=this.product.value;
        //this.ward_dropdownItem.name=this.product.name;
        this.selectstatus.value = this.product.status;
        this.selectstatus.name = this.product.status;
  
        this.selectgroupstatus.value = this.product.group_type;
        this.selectgroupstatus.name = this.product.group_type;

        this.end_pick_search={ "name": this.product.end_point?this.product.end_point.Label:'', "value":this.product.end_point?this.product.end_point:''};
        this.pick_search={ "name": this.product.pickup_point?this.product.pickup_point.Label:'', "value":this.product.pickup_point?this.product.pickup_point:''};
        
        this.place_details=this.product.pickup_point?this.product.pickup_point:'';
        this.end_place_details =this.product.end_point?this.product.end_point:'';

        
        this.product.start_time=this.format_time2(this.product.start_time);
        this.product.end_time=this.format_time2(this.product.end_time);
          this.village_dropdownItem=null;
          this.block_dropdownItem=null;
          this.district_dropdownItem=null;
          this.getDistrictData();
          this.getBlockData();
          //this.get_village();

        if (this.product.district_details && this.product.district_details.length>0) {
          this.district_dropdownItem={name:this.product.district_details[0].name,value:this.product.district_details[0].code};
        }
        if (this.product.block_details && this.product.block_details.length>0) {
          this.block_dropdownItem ={name:this.product.block_details[0].name,value:this.product.block_details[0].code}
        }
        if (this.product.villages_details && this.product.villages_details.length>0) 
        {
          this.village_dropdownItem ={ name:this.product.villages_details[0].village_name,value:this.product.villages_details[0].village_code };
           var search={value:this.product.villages_details[0].village_name};
          await  this.get_village(search);
        }
      },
      confirmDeleteProduct(product) {
        this.product = product;
        this.deleteProductDialog = true;
      },
      deleteProduct() {
        this.products = this.products.filter((val) => val.id !== this.product.id);
        this.deleteProductDialog = false;
        this.product = {};
        this.$toast.add({
          severity: "success",
          summary: "Successful",
          detail: "Product Deleted",
          life: 3000,
        });
      },
  
      deletegroup() {
        if (this.product._id) {
          var data = {
            id: this.product._id,
            user_id:localStorage.getItem("id")
          };
          this.isLoadingModel = true;
          var promise = apis.delete_group_master(data);
          promise.then((responseapi) => {
            this.isLoadingModel = false;
            if (responseapi.data.status == true) {
              // this.hideDialog1();
              this.deleteProductDialog = false;
              this.$swal(responseapi.data.message);
              this.get_list();
              this.get_count();
            } else {
              this.$swal("error to Delete Video");
            }
          });
        }
      },
      findIndexById(id) {
        let index = -1;
        for (let i = 0; i < this.products.length; i++) {
          if (this.products[i].id === id) {
            index = i;
            break;
          }
        }
        return index;
      },
      createId() {
        let id = "";
        var chars =
          "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        for (var i = 0; i < 5; i++) {
          id += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return id;
      },
      
    async  exportCSV() {
        this.limit=this.totalRecords;
        this.get_list();
       await this.$refs.dt.exportCSV();
      },
      confirmDeleteSelected() {
        this.deleteProductsDialog = true;
      },
      deleteSelectedProducts() {
        this.products = this.products.filter(
          (val) => !this.selectedProducts.includes(val)
        );
        this.deleteProductsDialog = false;
        this.selectedProducts = null;
        this.$toast.add({
          severity: "success",
          summary: "Successful",
          detail: "Products Deleted",
          life: 3000,
        });
      },
      initFilters() {
        this.filters = {
          global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        };
      },
    },
    components: {downloadExcel: JsonExcel,GoogleMap, Marker,MarkerCluster,InfoWindow,Polyline},
  };
  </script>
  
  <style scoped lang="scss">
  @import "../assets/demo/badges.scss";
  </style>
  